import SearchIconButton from './SearchIconButton';
import SearchIconButtonContainer from './SearchIconButton.container';

export default SearchIconButtonContainer(SearchIconButton);
